import { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2, Info, Loader2, XCircle } from "lucide-react";
import "./Toast.css";

export default function Toast({ tipo = "info", mensaje, onClose, duracion = 3000 }) {
  const [desapareciendo, setDesapareciendo] = useState(false);

  useEffect(() => {
    const tiempoVisible = Number(duracion) > 500 ? Number(duracion) : 3000;

    const mostrarTimer = setTimeout(() => {
      setDesapareciendo(true);
    }, tiempoVisible - 500);

    const ocultarTimer = setTimeout(() => {
      onClose();
    }, tiempoVisible);

    return () => {
      clearTimeout(mostrarTimer);
      clearTimeout(ocultarTimer);
    };
  }, [onClose, duracion]);

  const iconos = {
    exito: CheckCircle2,
    error: XCircle,
    advertencia: AlertTriangle,
    cargando: Loader2,
    info: Info,
  };

  const Icono = iconos[tipo] || Info;

  return (
    <div className={`toast-container toast-${tipo} ${desapareciendo ? "desaparecer" : ""}`}>
      <Icono className={`toast-icon ${tipo === "cargando" ? "spin" : ""}`} size={22} />
      <span className="toast-message">{mensaje}</span>
    </div>
  );
}
